import React from 'react';
import moment from 'moment';
import { observer } from 'mobx-react';
import MomentUtils from '@material-ui/pickers/adapter/moment';
import { LocalizationProvider, DateRangePicker } from '@material-ui/pickers';
import { Box, TextField, Typography } from '@material-ui/core';

import { getPath } from '../../../utils/getPath';
import { getPeriodDaysCount } from '../../../utils/getPeriodDaysCount';
import { declOfNum } from '../../../utils/declOfNum';

const PeriodPicker = observer(({ name, value = [null, null], onChange, required }) => {
    const renderDays = () => {
        if (value && value[0] && value[1]) {
            const days = getPeriodDaysCount(value);

            return `${days} ${declOfNum(days, ['день', 'дня', 'дней'])}`;
        }

        return 'Выберите период';
    };

    return (
        <LocalizationProvider dateAdapter={MomentUtils} locale="ru">
            <DateRangePicker
                mask="__.__.____"
                name={name}
                value={value}
                onChange={date => onChange(name, date)}
                showToolbar={false}
                renderInput={(startProps, endProps) => (
                    <div className="period-input">
                        <TextField
                            type="text"
                            value={value[0] ? `${moment(value[0]).format('DD.MM.YYYY')} - ${endProps.inputProps.value || 'Дата до'}` : ''}
                            onFocus={() => startProps.inputProps.onFocus()}
                            label="Даты аренды"
                            fullWidth
                            required={required}
                        />
                        <div className="period-input__calendar-btn">
                            <img src={getPath('public/img/calendar-month.svg')} alt="" />
                        </div>
                    </div>
                )}
            />

            <Box display="flex" justifyContent="space-between" mt={1}>
                <Typography variant="body2">Период аренды</Typography>
                <Typography variant="body2">{renderDays()}</Typography>
            </Box>
        </LocalizationProvider>
    );
});

export default PeriodPicker;
